/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import chain from 'chain-function';
import classnamesBind from 'classnames/bind';
import Overlay from './_Overlay';
import AskQuestion from '../AskQuestion/AskQuestion';
import lowerCase from '../utils/lowerCase';

const AskQuestionMenuItem = React.forwardRef((props, ref) => {
    const {
        classNameMap,
        cssBlock,
        name,
        id,
        onClose,
        ...otherProps
    } = props;

    const classnames = classnamesBind.bind(classNameMap);

    const [expanded, setExpanded] = useState(false);

    const handleToggleClick = () => {
        setExpanded(!expanded);
    };

    const handleClose = () => {
        setExpanded(false);
    };

    const drawToggle = () => {
        const anchorClassName = classnames(
            `${cssBlock}__anchor`,
            `${cssBlock}__anchor--tertiary`,
            {
                [`${cssBlock}__anchor--active`]: expanded,
            },
        );

        return (
            <li ref={ref}>
                <button
                    aria-expanded={expanded}
                    aria-haspopup="dialog"
                    className={anchorClassName}
                    data-test={id ? `menu-${lowerCase(id)}` : null}
                    onClick={handleToggleClick}
                    type="button"
                >
                    {name}
                </button>
            </li>
        );
    };

    return (
        <Overlay
            content={(
                <AskQuestion
                    {...otherProps}
                    onClose={chain(handleClose, onClose)}
                />
            )}
            disableEdgeDetection
            onHide={handleClose}
            placement="bottom-end"
            show={expanded}
            targetClassName={classnames(`${cssBlock}__target`)}
        >
            {drawToggle()}
        </Overlay>
    );
});

AskQuestionMenuItem.propTypes = {
    classNameMap: PropTypes.object,
    cssBlock: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    ...AskQuestion.propTypes,
};

AskQuestionMenuItem.defaultProps = {
    ...AskQuestion.defaultProps,
};

export default AskQuestionMenuItem;
